import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cn } from '../helpers/classnames';

interface Props {
  label: React.ReactNode;
  children: React.ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  contentClassName?: string;
}

const Tooltip: React.FC<Props> = ({
  label,
  children,
  side,
  contentClassName,
}) => {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          className={cn(
            'data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade',
            'z-[100001] select-none rounded-[4px] bg-background-600 px-[15px] py-[10px] text-[15px] leading-none text-text-50',
            'shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]',
            contentClassName,
          )}
          sideOffset={5}
        >
          {label}
          <RadixTooltip.Arrow className="fill-background-600" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};

export default Tooltip;
